import React, { useContext, useEffect, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { NavLink, useLocation } from 'react-router-dom';
import usersInfo from '../../assets/images/logo/users-info-side-bar-right.png';
import { withStyles } from '@material-ui/styles';
import sideRightStyles from './SideBarRight.styles';
import SelectionClinic from '../Clinics/index';
// import { MainDialog } from '../UI';
// import FormsSetting from '../Setting/Forms/FormsSetting';
import { useDispatch, useSelector } from 'react-redux';
import { listOfSelectPatients, setSelectedPatient } from '../../redux/Patient/PatientAction';
import LanguageContext from '../../contexts/languageContext';
import { Gender, MainDialog } from '../UI';
import { getAgeWithUnit } from '../../utils/dateTimeUtil';
import { CloseIcon } from '../UI/Images/Icons';
import { PropTypes } from 'prop-types';
import ClosePatient from './ClosePatient';
import { useIndexedDB } from 'react-indexed-db';
import useRoutes from '../../Routes/useRoutes';
import useCheckAccess from '../../hooks/useCheckAccess';
import Profile from '../../pages/Profile';
import useCheckMobileScreen from '../../hooks/useWidth';

export const LightTooltip = withStyles(() => ({
    arrow: {
        color: '#E6E8ED',
        fontSize: '11px'
    },
    tooltip: {
        boxShadow: '0 2px 8px 0 rgba(84, 94, 102, 0.12)',
        backgroundColor: '#ebf0ff',
        fontFamily: 'inherit',
        color: '#232733',
        padding: '2px 10px',
        fontSize: '12px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.79',
        letterSpacing: 'normal',
        textAlign: 'right',
        margin: '0px'
    }
}))(Tooltip);

const SideBarRight = () => {
    const [open] = useState(true);
    const [dialog, setDialog] = useState(false);
    const { lang } = useContext(LanguageContext);
    const isMobile = useCheckMobileScreen();
    const { pathname } = useLocation();
    const url = pathname?.split('/')[4];
    // const path = `/${params.section}/patient/${params.id}`;
    const dispatch = useDispatch();
    const classes = sideRightStyles({ open, rtl: lang === 'fa' });
    const patients = useSelector((state) => state?.patient?.listOfPatients);
    const { handleClosePatient } = ClosePatient();
    const { getAll } = useIndexedDB('patients');
    const clinicId = pathname?.split('/').filter((item) => item)[0];
    const { mainRoutes, settingRoutes } = useRoutes();
    const { notEditClinical } = useCheckAccess();
    const setting = mainRoutes?.find((item) => item.name === 'setting');

    useEffect(() => {
        getAll().then((items) => {
            dispatch(listOfSelectPatients(items));
        });
    }, []);

    // const handleGoBack = () => {
    //     history.goBack();
    // };
    const handlePatient = (patient) => {
        dispatch(setSelectedPatient(patient));
    };

    const ToolTipDetail = ({ patient }) => {
        ToolTipDetail.propTypes = {
            patient: PropTypes.object
        };
        return (
            <div className={classes.tooltipDetailRow}>
                <div className={classes.tooltipDetailRow}>
                    <CloseIcon onClick={() => handleClosePatient(patient)} />
                    <div className={classes.tooltipDetailRow}>
                        <span className={classes.age}>
                            {patient?.dob && getAgeWithUnit(patient.dob).age}
                        </span>
                        {patient?.gender && <Gender height="20" gender={patient?.gender} />}
                    </div>
                </div>
                <div>
                    {patient.first_name} {patient.last_name}
                </div>
            </div>
        );
    };
    if (isMobile) {
        return null;
    }
    return (
        <>
            <div className={classes.sideRight}>
                <div className={classes.column}>
                    <div>
                        <div className={classes.wrapper}>
                            {mainRoutes
                                ?.filter(
                                    (item) => item.name !== 'setting' && item.isSideBar !== false
                                )
                                ?.map((item) => (
                                    <div key={item.id}>
                                        <LightTooltip placement="left" title={item.tooltip} arrow>
                                            <NavLink
                                                to={item.link}
                                                activeClassName={classes.activeIcon}
                                                exact
                                                data-testid={item.name}
                                            >
                                                {item.icon}
                                            </NavLink>
                                        </LightTooltip>
                                    </div>
                                ))}
                            <div className={classes.selectedPatients}>
                                {patients?.map((patient) => (
                                    <LightTooltip
                                        key={patient.id}
                                        placement="left"
                                        title={<ToolTipDetail patient={patient} />}
                                        interactive
                                        arrow
                                    >
                                        <NavLink
                                            onClick={() => handlePatient(patient)}
                                            to={`/${clinicId}/patient/${patient.id}/${
                                                notEditClinical ? 'profile' : url || 'forms/form'
                                            }`}
                                            activeClassName={classes.active}
                                            data-testid="selectPatient"
                                        >
                                            <span
                                                // style={{
                                                //     direction: isPersian(patient.last_name)
                                                //         ? 'rtl'
                                                //         : 'ltr'
                                                // }}
                                                className={classes.selectedPatientsLink}
                                            >
                                                {patient.last_name}
                                            </span>
                                        </NavLink>
                                    </LightTooltip>
                                ))}
                            </div>
                        </div>
                        {/* <div className={classes.calenderIconWrapper}>

                        </div> */}
                    </div>
                    <div className={classes.iconsContainer}>
                        <div className={classes.lineSeparator} />
                        {setting?.name && (
                            <div className={classes.img}>
                                <NavLink
                                    to={`${setting.link}/${settingRoutes[0]?.name}`}
                                    activeClassName={classes.activeIcon}
                                    data-testid="setting"
                                >
                                    {setting.icon}
                                </NavLink>
                            </div>
                        )}

                        <SelectionClinic />

                        <div className={classes.img}>
                            <img
                                src={usersInfo}
                                onClick={() => setDialog(true)}
                                data-testid="userInfo"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <MainDialog
                open={dialog}
                goBack={() => {
                    setDialog(false);
                }}
            >
                <Profile />
            </MainDialog>
        </>
    );
};

export default SideBarRight;
